<!-- HANDY DEBUGGING LINKS -->
@if (enableDebugging) {
  <div style="background-color: black; color: lawngreen; border-radius: 4px; padding: 4px; margin-top: 8px">
    <div style="text-align: center; font-weight: bold; text-decoration: underline" (click)="showDebugLinks = !showDebugLinks">
      DEBUG HELPERS
    </div>
    @if (showDebugLinks) {
      <div style="display: grid; grid-template-columns: 50% 50%">
        <div>
          <button style="display: block; background-color: green; color: greenyellow; cursor: pointer" (click)="dumpAddInInfo()">Info</button>
          <button style="display: block; background-color: green; color: greenyellow; cursor: pointer" (click)="dumpModel()">Dump Model</button>
          <button style="display: block; background-color: green; color: greenyellow; cursor: pointer" (click)="dumpObjectAtSelection()">
            Dump Selected Object
          </button>
          <button style="display: block; background-color: green; color: greenyellow; cursor: pointer" (click)="dumpContentControls()">
            Content Controls
          </button>
          <button style="display: block; background-color: green; color: greenyellow; cursor: pointer" (click)="toggleDebugPanel()">
            Debug Panel
          </button>
        </div>
        <div style="display: grid; grid-template-columns: 90% 10%; color: white">
          <div style="text-align: right; margin-right: 8px">Condition</div>
          <div style="background-color: #0000ff">&nbsp;</div>
          <div style="text-align: right; margin-right: 8px">Iterable</div>
          <div style="background-color: #00ff00">&nbsp;</div>
          <div style="text-align: right; margin-right: 8px">Container</div>
          <div style="background-color: #aa00aa">&nbsp;</div>
          <div style="text-align: right; margin-right: 8px">Image</div>
          <div style="background-color: #333f48">&nbsp;</div>
          <div style="text-align: right; margin-right: 8px">Other</div>
          <div style="background-color: #ffbe50">&nbsp;</div>
        </div>
      </div>
    }
    <app-bbar></app-bbar>
  </div>
}
